import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';


const LeadOpp = ( { aid, uid, meta, opps, contacts } ) => {
    let params = useParams();
    const [ lo, setOpp ] = useState( {
        details: {},
        members: []
    } );
    // useEffect( () => {
    //     load( { aid: aid, uid: uid, loid: params.loid } );
    // }, [ aid, uid, params.loid, load ] );

    // useEffect( () => {
    //     console.log( 'lo:', lo );
    // }, [ lo ] );

    useEffect( () => {
        const list = [];
        if ( opps[params.loid]?.relationships?.length ) {
            opps[params.loid].relationships.forEach( r => {
                if ( contacts[r.cid] ) {
                    list.push( { ...contacts[r.cid], ...r } );
                }
            } );
        }
        if ( opps ) {
            setOpp( prev => {
                return {
                    ...prev,
                    details: opps[params.loid],
                    members: list
                }
            } );
        }
    }, [ params.loid, opps, contacts ] );

    useEffect( () => {
        document.title = `Third Floor - ${lo?.details?.name}`;
    }, [ lo ] );

    return (
        <TFObject key={params.loid} objType='leadopp' obj={lo} oid={params.loid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    uid: state.user.email,
    meta: state.user.meta.leadopp,
    // lo: state.leadopps.current
    opps: state.leadopps.byId,
    contacts: state.contacts.byId
} );

const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.leadopps.loadLeadOpp
} );

export default connect( mapProps, mapDispatch )( LeadOpp );